import { MainLayout } from "../../layouts";

const Show = () => {
  return (
    <MainLayout></MainLayout>
  );
};

export default Show;
